import React, { useState } from "react";
import { ButtonClose, ButtonPopup } from "../ui";
import CookieConsentModal from "../docs/CookieConsentModal";
import { useNavigate } from "react-router-dom";

const CookiePolicy: React.FC = () => {
  const [showCookieModal, setShowCookieModal] = useState(false);


  const navigate = useNavigate();

  const handleClose = () => {
    navigate(-1); // 👈 vuelve atrás
  };

  return (
    <div
      className="w-full h-screen flex items-center justify-center px-4 py-8 bg-cover bg-center relative "
      style={{ backgroundImage: "url('/img/politicas/fondoLinkservs.png')" }}
    >
      {/* 🔹 Overlay oscuro */}
      <div className="absolute inset-0 bg-black/30 backdrop-blur-sm" />

      {/* 🔹 Card principal */}
      <div className="relative z-10 w-[210mm] max-w-full max-h-[90vh] overflow-hidden rounded-2xl border border-white/20 shadow-2xl bg-black/30 backdrop-blur-xs">

        {/* 🔹 Contenido scrollable */}
        <div className="p-8 overflow-y-auto max-h-[90vh] text-white">

          <div className="flex justify-end">
            <ButtonClose onClick={handleClose} />
          </div>

          <h1 className="text-3xl font-semibold text-center mb-6 text-white">
            Política de Cookies
          </h1>

          <section className="text-lg leading-relaxed mb-8">

            <p className="mb-4">
              Cuadranex S.L. como responsable de esta plataforma <strong>www.LinkServs.com</strong> dedicada a la visivilidad y unión de profesionales, informa a sus usuarios de que utilizamos dispositivos de almacenamiento y recuperación de datos (COOKIES) para analizar la navegación y mejorar la interacción entre los distintos profesionales presentes en nuestro sitio web.
            </p>

            <h2 className="text-2xl font-semibold mb-4">Que son las cookies</h2>

            <p className="mb-4">
              Las cookies son archivos que se descargan en su equipo al acceder a determinadas páginas web. Permiten a una web, entre otras cosas, almacenar y recuperar información sobre los hábitos de navegación de un usuario o de su equipo y, dependiendo de la información que contengan, pueden utilizarse para reconocer al usuario.
            </p>

            <p className="mb-4">
              Puedes obtener más información y configurar tus preferencias{" "}
              <button
                onClick={() => setShowCookieModal(true)}
                className="text-blue-600 underline"
              >
                AQUÍ
              </button>.
            </p>
          </section>

          <section className="text-lg leading-relaxed mb-8">
            <h2 className="text-2xl font-semibold mb-4">Tipos de cookies utilizadas</h2>

            <p className="mb-4">
              Para cumplir con nuestra misión de dar visibilidad a todas las profesiones, utilizams los siguientes tipos:
            </p>

            <ul className="list-disc pl-6 mb-4">
              <li><strong>Cookies Técnicas:</strong>Necesarias para el funcionamiento de la web y el acceso a los directorios de profesionales</li>
              <li><strong>Cookies de Análisis</strong>Aquellas que nos permiten cuantificar el número de usuarios y realizar la medición y análisis estadístico de la utilización que hacen los usuarios de los servicios ofrecidos</li>
              <li><strong>Cookies de Personalización:</strong>Permiten al usuario acceder al servicio con algunas características de caracter general predefinidas, (por ejemplo, el idioma o tipo de busqueda).</li>
            </ul>
          </section>

          <section className="text-lg leading-relaxed mb-8">
            <h2 className="text-2xl font-semibold mb-4">Cuadro de Cookies</h2>
            <ul className="list-disc pl-6 mb-4">
              <li><strong>_utma:</strong>Google Analytics → Identifica a los usuarios únicos y sesiones → Caduca al año.</li>
              <li><strong>_utmb:</strong>Google Analytics → Se usa para determinar nuevas sesiones o visitas → Caduca en 30 minutos.</li>
              <li><strong>_utmc:</strong>Google Analytics → Funciona con _utmb para saber si se ha abierto → Caduca al cerrar la sesión en el navegador.</li>
              <li><strong>_utmc:</strong>Google Analytics → Almacena la fuente del tráfico.</li>
            </ul>
          </section>

          <section className="text-lg leading-relaxed mb-8">

            <p className="mb-4">
              Estas cookies son de tipo propio, de sesión y de análisis. No recogen datos personales, pero sí información como el número de usuarios, páginas vistas, duración de las visitas, tipo de navegador, ciudad de origen, etc. Toda esta información es procesada directamente por Google. Puedes obtener más información o desactivar estas cookies en{" "}
              <a
                href="https://support.google.com/analytics/answer/6004245?hl=es"
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 hover:underline"
              >
                este enlace.
              </a>
            </p>
          </section>

          <ButtonPopup onClick={handleClose}>Cerrar</ButtonPopup>

          {showCookieModal ? (
            <CookieConsentModal onClose={() => setShowCookieModal(false)} />
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default CookiePolicy;
